import React, { useContext } from "react";

import { Link } from "react-router-dom";

import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";
import IconDropDown from "ui/Dropdown/iconDropDown";
import IconDelete from "ui/Dropdown/iconDelete";
import IconShare from "ui/Dropdown/iconShare";
import { randomString } from "hooks/helper";

const UITopic = (props) => {
  const { globalState } = useContext(GlobalContext);
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);

  let modalShare = <div></div>;

  let shareLink = () => {
    let link = "https://world.reaches.me/topic/" + props.sub.mtopic;

    props.share(props.sub.topic_display_name || props.sub.topic, link);

    // var share_modal = document.getElementById("share_modal");
    // document.getElementById("share_modal_link_title").innerHTML =
    //   props.sub.topic_display_name || props.sub.topic;
    // document.getElementById("share_modal_link").innerHTML = link;

    // share_modal.style.display = "block";

    // document.getElementById("share_modal").style.display = "block";
  };

  const destroyTopic = () => {
    if (
      window.confirm(
        'Are you sure you want to delete "' +
          (props.sub.topic_display_name || props.sub.topic) +
          '"?\nIf you are the topic owner, it will be deleted for all users.\nOtherwise it will only be deleted for you.\n'
      )
    ) {
      let j = {
        type: "w.topic.destroy",
        mtopic: props.sub.mtopic,
        persona: props.sub.persona,
        version: globalState.version,
        smid: randomString(8),
      };
      databaseState.dbMaster &&
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            jmessage: j,
            db: databaseState.dbMaster,
            collection: "send",
            table: "confirm_smid",
            rowid: j.smid,
            doc: j,
          },
        });
    } else {
    }
  };

  const menuItems = [
    {
      icon: <IconShare />,
      callback: shareLink,
    },
    {
      icon: <IconDelete />,
      callback: destroyTopic,
    },
  ];

  let content = (
    <div>
      <div>
        <div className="UI-topic">
          {modalShare}
          <Link
            key={props.sub.mtopic}
            className="UI-topic-link"
            style={{ color: "#add036", textDecoration: "none" }}
            to={{
              pathname: "/UIMessageList",
              state: {
                subscription: props.sub,
              },
            }}
          >
            <li className="UI-topic-link">
              <div className="UI-topic-inner">
                <div className="UI-topic-tdn hide-scrollbar">
                  {props.sub.topic_display_name || props.sub.topic}
                </div>
                <div className="UI-topic-persona hide-scrollbar">
                  {props.sub.persona}
                </div>
                <div className="UI-topic-count">
                  {databaseState.liveCount[props.sub.mtopic]}
                </div>
              </div>
            </li>
          </Link>
          <IconDropDown className=".UI-icondropdown" menuItems={menuItems} />
        </div>
      </div>
    </div>
  );

  return content;
};

export default React.memo(UITopic, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
